module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "section"
    }
  }, [_c('h1'), _vm._v(" "), _c('p', [_vm._v("The reason why I wanted to write this book was to help disabled people. I wanted to stop the stigma that they feel daily, to make them feel included in society. It also happens to be a hidden part of human history which isn’t talked about. In order to truly understand disability, I knew I had to start from the beginning through its history. There’s a quote from Rod Laver which still means a lot to me, "), _c('em', [_vm._v("in order to find the true understanding of something, you’ve got to learn about its history and see how it has evolved over time.")]), _vm._v(" Which exactly what this book sets out to do. This book is here to teach the world that disabled people are the same as able-bodied people. They have the same feelings, dreams and ambitions in life as we do but because they look different, they are misrepresented. When I can prove that our mind is what defines us not our bodies, I really hope you take this newfound information, help disabled people, don’t ignore them; it’s not their fault they have the bodies they have—it’s genetics. Thank you so much for reading it.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_c('em', [_vm._v("Molly Seymour")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a817782","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch004.vue
// module id = 72
// module chunks = 0